import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054841bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "in" }, null, -1))

import Coin from "@/components/SuperMario/Coin.vue";
import { ref } from "vue";
import { useGsap } from "@/hooks/useGsap";
import { random } from "@/helpers/random";


export default /*#__PURE__*/_defineComponent({
  __name: 'Block',
  props: {
    hasCoin: { type: Boolean },
    hasFoundAllCoins: { type: Boolean }
  },
  emits: ["jumped", "foundCoin", "foundAllCoins"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  hasCoin: boolean;
  hasFoundAllCoins: boolean;
}




const gsap = useGsap();
const hasTouched = ref(false);
const block = ref<HTMLElement | null>(null);
const audioStomp = new Audio("/smw_stomp.ogg");
const audioNoDamage = new Audio("/smw_stomp_no_damage.ogg");
const audioAppears = new Audio("/smw_power-up_appears.ogg");

function animateCoin() {
  if (!block.value) {
    return;
  }

  const xCoords = random(-150, 150);
  const coin = block.value.children[1];
  const coinAnimation = gsap.timeline();

  coinAnimation
    .set(coin, {
      autoAlpha: 1,
      xPercent: 0,
      yPercent: 0,
    })
    .to(coin, 0.1, { yPercent: -100 })
    .to(coin, 1, {
      motionPath: [
        { xPercent: xCoords, yPercent: random(-150, -100) },
        { xPercent: xCoords * 2, yPercent: 800 },
      ],
      ease: "steps(24)",
    });

  audioAppears.play();
  emits("foundCoin");
}

function onTouchBlock() {
  hasTouched.value = true;
  animateBlock();

  if (props.hasFoundAllCoins) {
    audioNoDamage.play();
    return;
  }

  if (props.hasCoin) {
    audioStomp.play();
    animateCoin();
  } else {
    audioNoDamage.play();
  }
}

function animateBlock() {
  hasTouched.value = true;

  emits("jumped", block.value);

  const blockAnimation = gsap.timeline();

  blockAnimation
    .clear(true)
    .set(block.value, { yPercent: 0 })
    .to(block.value, 0.07, { yPercent: -40, ease: "steps(2)" })
    .to(block.value, 0.07, { yPercent: 0, ease: "steps(2)" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(['mario-box', { '-jumped': hasTouched.value }]),
      onClick: onTouchBlock,
      ref_key: "block",
      ref: block
    }, [
      _hoisted_1,
      _createVNode(Coin, { id: "coin" })
    ], 2)
  ]))
}
}

})